/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneTextSubtitle from 'base/components/standalone/TextSubtitle';

export const DynamicStandaloneTextSubtitle = StandaloneTextSubtitle;
export type DynamicStandaloneTextSubtitleProps = PropsFromComponent<typeof StandaloneTextSubtitle>;

export const DynamicStandaloneTextSubtitleWith = (extras: DynamicStandaloneExtras): typeof StandaloneTextSubtitle => {
    return function DynamicStandaloneTextSubtitle(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'TextSubtitle');
        return <StandaloneTextSubtitle {...mergeProps({ options: { theme } }, props)} />;
    }
}